$(function () {
    // When the window has finished loading, add the loaded class to the body.
    document.body.classList.add('loaded');

    document.getElementById('preloader').style.display = 'none'
});